import React, { ReactNode } from 'react'
import { Row, Col, Typography, Grid, Button } from 'src/antd'
import styled from 'styled-components'

import { AppVersion } from 'src/appVersion'
import { CurrentUrlStatus } from 'src/new-components/forms/app-config/CurrentUrlStatus'
import { changeApiUrl } from 'src/new-components/other/ApiUrl'

import authBgMobile from './bg-mobile.svg'
import authBackground from './bg.svg'
import Logo from '../../../images/logo.svg'

export type AuthLayoutProps = {
  footer?: ReactNode
  title: ReactNode
}

const { useBreakpoint } = Grid

const Wrapper = styled(Row)`
  min-height: 100vh;
  min-width: 100vw;
  background-image: url(${authBackground});
  background-color: #111d2c;
  background-size: cover;
  background-position: bottom;
  background-repeat: no-repeat;
  padding: 20px 30px;
  #brand-logo {
    height: 40px;
  }

  #content-wrapper {
    align-self: center;
  }

  #footer-wrapper {
    align-self: flex-end;

    @media only screen and (max-width: 330px) {
      font-size: small;
    }
  }

  label {
    color: white;
  }

  @media only screen and (max-width: 1000px) {
    & {
      background-size: contain;
      padding-bottom: 8px;
    }
  }

  @media only screen and (max-width: 576px) {
    & {
      background-image: url(${authBgMobile});
    }
  }
`

const AuthLayout: React.FC<AuthLayoutProps> = ({ footer, title, children }) => {
  const { xs } = useBreakpoint()

  return (
    <Wrapper align="top" justify="center" gutter={[0, xs ? 80 : 50]}>
      <Col xs={24} id="content-wrapper">
        <Row justify="center" gutter={[0, 50]}>
          <Col xs={24}>
            <Row justify="center">
              <img src={Logo} alt="Wastehero" id="brand-logo" />
            </Row>
          </Col>
          <Col xs={24}>
            <Row justify="center">
              <Typography.Title level={3} style={{ color: `white` }}>
                {title}
              </Typography.Title>
            </Row>
          </Col>
          <Col xs={24}>
            <Row justify="center">{children}</Row>
          </Col>
        </Row>
      </Col>
      <Col xs={24} id="footer-wrapper">
        <Row justify="center">{footer}</Row>
        <div className="center-child" style={{ display: 'flex' }}>
          <Button type="text" onClick={() => changeApiUrl()}>
            <>
              <AppVersion />
            </>
          </Button>
          <CurrentUrlStatus />
        </div>
      </Col>
    </Wrapper>
  )
}

export default AuthLayout
